export function isUndefined<T>(value: T | undefined): value is undefined {
  return value === undefined;
}

export function assertIsUndefined<T>(
  value: T | undefined
): asserts value is undefined {
  if (!isUndefined(value)) {
    throw new TypeError(`Value is not undefined.`);
  }
}

export function isNotUndefined<T>(value: T | undefined): value is T {
  return value !== undefined;
}

export function assertIsNotUndefined<T>(
  value: T | undefined
): asserts value is T {
  if (!isNotUndefined(value)) {
    throw new TypeError(`Value is undefined.`);
  }
}
